import { ApiPaths } from 'api/constants';
import { ProcessGeneral } from 'api/endpoints/processes';
import {
  ScanConfigurationGeneral,
  UpdateScanConfig,
} from 'api/endpoints/processScan';
import ApiUrlParams from 'constants/apiUrlParams';
import { ApiResponseAsync } from 'container/models';
import {
  getReleaseOrDraftID,
  ProcessDraftOrRelease,
} from 'types/processDraftOrRelease';

import BaseRepo from '../../BaseRepo';
import {
  CONFIG_STOP_PATHS,
  IScanScenarioRepo,
  ScanScenario,
} from './IScanScenarioRepo';

export class ScanScenarioRepo extends BaseRepo implements IScanScenarioRepo {
  getScanScenario = (
    process: ProcessDraftOrRelease,
    scanScenarioId: string
  ): ApiResponseAsync<ScanScenario> =>
    this.helpers.handleGet<ScanScenario>(
      ApiPaths.processes.byId.scanning.configurations.byId._({
        [ApiUrlParams.scanConfigurationId]: scanScenarioId,
        [ApiUrlParams.releaseOrDraftProcessId]: getReleaseOrDraftID(process),
      }),
      { responseStopTransformPaths: CONFIG_STOP_PATHS }
    );

  getAllScanScenarios = (
    process: ProcessDraftOrRelease
  ): ApiResponseAsync<DataWithTotal<ScanConfigurationGeneral>> =>
    this.helpers.handleGet(
      ApiPaths.processes.byId.scanning.configurations._({
        [ApiUrlParams.releaseOrDraftProcessId]: getReleaseOrDraftID(process),
      })
    );

  createScanScenario = (
    process: ProcessGeneral,
    params: UpdateScanConfig
  ): ApiResponseAsync<ScanConfigurationGeneral> =>
    this.helpers.handlePost(
      ApiPaths.processes.byId.scanning.configurations._({
        [ApiUrlParams.releaseOrDraftProcessId]: process.id,
      }),
      params.data,
      { requestStopTransformPaths: CONFIG_STOP_PATHS }
    );

  updateScanScenario = (
    process: ProcessGeneral,
    scenario: ScanConfigurationGeneral,
    params: UpdateScanConfig
  ): ApiResponseAsync<ScanConfigurationGeneral> =>
    this.helpers.handlePut(
      ApiPaths.processes.byId.scanning.configurations.byId._({
        [ApiUrlParams.scanConfigurationId]: scenario.id,
        [ApiUrlParams.releaseOrDraftProcessId]: process.id,
      }),
      params.data,
      { requestStopTransformPaths: CONFIG_STOP_PATHS }
    );

  deleteScanScenario = (
    process: ProcessGeneral,
    scenario: ScanConfigurationGeneral
  ): ApiResponseAsync<unknown> =>
    this.helpers.handleDelete(
      ApiPaths.processes.byId.scanning.configurations.byId._({
        [ApiUrlParams.releaseOrDraftProcessId]: process.id,
        [ApiUrlParams.scanConfigurationId]: scenario.id,
      })
    );
}
